import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { translate, TranslocoService } from '@ngneat/transloco';

declare var require: any;
import * as _ from 'lodash-es';


@Component({
  selector: 'app-account-pricing2024',
  templateUrl: './pricing2024.component.html',
  styleUrl: './pricing2024.component.scss'
})
export class Pricing2024Component {

  features: any;
  recommended: any;
  info:any;
  message_alert: any;
  original: any;
  changed = false;

  formGroup :any;

  submitted = false;


  get f(): { [key: string]: AbstractControl } {
    return this.formGroup.controls;
  }

  constructor(private router: Router, private route: ActivatedRoute, public okService: OkAloneService, private transloco: TranslocoService) { }

  ngOnInit(): void {

    this.okService.doDismiss('features_menu_badge')

    this.getFeatures();

  }


  getFeatures(){

    this.okService.get("features",{"expand":"features,info,recommended"})
    .subscribe((data:any) => {

      this.features = data.body['features'];
      if(!this.original){
        this.original = data.body['features'];
      }
      this.info = data.body['info'];
      this.recommended = data.body['recommended'];

      //console.log('features',this.features);
      //console.log('info',this.info);
      //console.log('billing',this.okService.billing);
      this.setForm();

    })
  }

  setForm(){

    //console.log(this.features);
    //console.log(this.info);

    this.formGroup = new FormGroup({

      // Lone Worker Essentials
      groups: new FormControl(this.features.groups,[]),
      timesheets: new FormControl(this.features.timesheets,[]),
      worker_reports: new FormControl(this.features.worker_reports,[]),
      safety_awards: new FormControl(this.features.safety_awards,[]),
      learning_center: new FormControl(this.features.learning_center,[]),
      what3words: new FormControl(this.features.what3words,[]),

      // Automated Monitoring
      checkin_reminders: new FormControl(this.features.checkin_reminders,[]),
      alert_loops: new FormControl(this.features.alert_loops,[]),
      out_of_hours: new FormControl(this.features.out_of_hours,[]),
      start_end_shift: new FormControl(this.features.start_end_shift,[]),
      email_reminder: new FormControl(this.features.email_reminder,[]),
      flex_delay: new FormControl(this.features.flex_delay),
      action_notices: new FormControl(this.features.action_notices,[]),
      auto_end_shift: new FormControl(this.features.auto_end_shift,[]),
      send_messages: new FormControl(this.features.send_messages,[]),

      
      // Safety Monitoring Center
      emergency_response: new FormControl(this.features.emergency_response,[]),

      // Business Plus Add-On
      fa2: new FormControl(this.features.fa2,[]),
      ihelp: new FormControl(this.features.ihelp,[]),
      zoleo: new FormControl(this.features.zoleo,[]),
      integrations: new FormControl(this.features.integrations,[]),
      spot: new FormControl(this.features.spot,[]),
      zapier: new FormControl(this.features.zapier,[]),
      force_password_reset: new FormControl(this.features.force_password_reset,[]),
      map_zones: new FormControl(this.features.map_zones,[]),
      worker_reports_scheduled: new FormControl(this.features.worker_reports_scheduled,[]),
      access: new FormControl(this.features.access,[]),
      api_integration: new FormControl(this.features.api_integration,[]),
      safety_zones: new FormControl(this.features.safety_zones,[]),
      teams_notifications: new FormControl(this.features.teams_notifications,[]),
      app_connectivity: new FormControl(this.features.app_connectivity,[]),
      sso: new FormControl(this.features.sso,[]),
      privacy_mode: new FormControl(this.features.privacy_mode,[]),
      offenders: new FormControl(this.features.offenders,[]),
      threat_zones: new FormControl(this.features.threat_zones,[]),
      team_broadcast: new FormControl(this.features.team_broadcast,[]),

      // App features
      timer: new FormControl(this.features.timer,[]),
      checkin: new FormControl(this.features.checkin,[]),
      highrisk: new FormControl(this.features.highrisk,[]),
      mandown: new FormControl(this.features.mandown,[]),
      help: new FormControl(this.features.help,[]),
      shift: new FormControl(this.features.shift,[]),
      shake: new FormControl(this.features.shake,[]),
      timed_activity: new FormControl(this.features.timed_activity,[]),
      enhanced_gps: new FormControl(this.features.enhanced_gps,[]),
      license_mgmt: new FormControl(this.features.license_mgmt,[]),
      panic_button: new FormControl(this.features.panic_button,[]),
      panic_hold: new FormControl(this.features.panic_hold,[]),
      shutdown_log: new FormControl(this.features.shutdown_log,[]),
      shutdown_alert: new FormControl(this.features.shutdown_alert,[]),
      motion_heartbeat: new FormControl(this.features.motion_heartbeat,[]),
      motion_heartbeat_activity: new FormControl(this.features.motion_heartbeat_activity,[]),
      app_mfa: new FormControl(this.features.app_mfa,[]),
      app_links: new FormControl(this.features.app_links,[]),
      sosbutton: new FormControl(this.features.sosbutton,[]),
      fall_detection: new FormControl(this.features.fall_detection,[]),
      two_way_audio: new FormControl(this.features.two_way_audio,[]),
    });

    this.formGroup.controls['emergency_response'].disable();
    this.formGroup.controls['privacy_mode'].disable();
    this.formGroup.controls['threat_zones'].disable();
    this.formGroup.controls['team_broadcast'].disable();
    this.formGroup.controls['offenders'].disable();

    if(!this.okService.isDemoAccount() && !this.okService.isFromAdmin() && !this.okService.isSuperAdmin()){
      this.formGroup.controls['timer'].disable();
      this.formGroup.controls['checkin'].disable();
      this.formGroup.controls['highrisk'].disable();
      this.formGroup.controls['mandown'].disable();
      this.formGroup.controls['help'].disable();
      this.formGroup.controls['shift'].disable();
      this.formGroup.controls['shake'].disable();
      this.formGroup.controls['timed_activity'].disable();
      this.formGroup.controls['fall_detection'].disable();
      this.formGroup.controls['sosbutton'].disable();
      this.formGroup.controls['two_way_audio'].disable();

      this.formGroup.controls['panic_hold'].disable();
      this.formGroup.controls['shutdown_log'].disable();
      this.formGroup.controls['shutdown_alert'].disable();
      this.formGroup.controls['app_mfa'].disable();


      if(this.okService.billing && this.okService.billing.plan){

        if(this.okService.billing.plan.comms_active !== true){
          // Disable Automated Monitoring
          this.formGroup.controls['checkin_reminders'].disable();
          this.formGroup.controls['alert_loops'].disable();
          this.formGroup.controls['out_of_hours'].disable();
          this.formGroup.controls['start_end_shift'].disable();
          this.formGroup.controls['email_reminder'].disable();
          this.formGroup.controls['flex_delay'].disable();
          this.formGroup.controls['action_notices'].disable();
          this.formGroup.controls['auto_end_shift'].disable();
          this.formGroup.controls['send_messages'].disable();
        }
  
        if(this.okService.billing.plan.business_addon_plan !== true){
  
          // Disable Business Plus Add-On
          this.formGroup.controls['fa2'].disable();
          this.formGroup.controls['ihelp'].disable();
          this.formGroup.controls['zoleo'].disable();
          this.formGroup.controls['integrations'].disable();
          this.formGroup.controls['spot'].disable();
          this.formGroup.controls['zapier'].disable();
          this.formGroup.controls['force_password_reset'].disable();
          this.formGroup.controls['map_zones'].disable();
          this.formGroup.controls['worker_reports_scheduled'].disable();
          this.formGroup.controls['access'].disable();
          this.formGroup.controls['api_integration'].disable();
          this.formGroup.controls['safety_zones'].disable();
          this.formGroup.controls['enhanced_gps'].disable();
          this.formGroup.controls['license_mgmt'].disable();
          this.formGroup.controls['app_links'].disable();
          this.formGroup.controls['sso'].disable();
          // this.formGroup.controls['teams_notifications'].disable();

        }
  
      }

    }

    for (var key in this.info) {
      if(this.features[key] == true){
        if(this.formGroup.controls[key]){
          this.formGroup.controls[key].disable();
        }
      }

    }

    if(this.okService.isUsDataRegion()){
      this.formGroup.controls['safety_awards'].setValue(false);
      this.formGroup.controls['safety_awards'].disable();
      this.formGroup.controls['learning_center'].setValue(false);
      this.formGroup.controls['learning_center'].disable();
    }

  }

  updateFeatures(features:any){

    //console.log(features);
    this.changed = true;

    this.okService.put("features",{features:features})
    .subscribe((data:any) => {

      //console.log(data.body);

      this.features = data.body['features'];

      this.okService.features = this.features;

      this.setForm();

      this.okService.setAlert(this.transloco.translate("Your settings have been updated"),"success");

      this.okService.toggleMenuUpdate();

    });

  }


  submitForm(){

    this.submitted = true;
    if (
      this.formGroup.valid
      ) {

        let values = _.merge(this.okService.features,this.formGroup.value);
        if(this.okService.isUsDataRegion()){
          values.safety_awards = false;
          values.learning_center = false;
        }
        //console.log(values);

        this.updateFeatures(values);
      }

    return false;

  }

  enableRecommended(){
    this.features = this.recommended;
    this.updateFeatures(this.features);
  }

  enableAll(){
    for (var key in this.features) {
      this.features[key] = true;
    }
    this.updateFeatures(this.features);
  }

  enableUndo(){
    this.features = this.original;
    this.updateFeatures(this.features);
  }

  goToWorker(tab:any){

    // let worker = this.okService.workers[0];
    // this.router.navigateByUrl("/mgmt/worker/"+worker.id+"?tab="+tab);
    this.router.navigateByUrl("/mgmt/workers/workers");

  }

  goToMonitor(){

    let monitor = this.okService.monitors[0];
    this.router.navigateByUrl("/mgmt/monitor/"+monitor.id);

  }

}
